// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>

const REQUEST_PARCEL_SHOPS = 'REQUEST_PARCEL_SHOPS';
const REQUEST_PARCEL_SHOPS_SUCCESS = 'REQUEST_PARCEL_SHOPS_SUCCESS';
const REQUEST_PARCEL_SHOPS_FAILED = 'REQUEST_PARCEL_SHOPS_FAILED';

const PARCEL_SHOPS_CHANGE_FIELD = 'PARCEL_SHOPS_CHANGE_FIELD';

const SET_POSTCODE = 'SET_POSTCODE';

export {
  REQUEST_PARCEL_SHOPS,
  REQUEST_PARCEL_SHOPS_SUCCESS,
  REQUEST_PARCEL_SHOPS_FAILED,

  PARCEL_SHOPS_CHANGE_FIELD,

  SET_POSTCODE,
};
